import './About.css'
import { FaHome } from 'react-icons/fa'
import AboutImg from '../../assets/images/about-banner-1.png'
import Img from '../../component/Img'



const About = () => {
  return (
    <>
      <div className='linei'></div>
      <div className="about container" id='about'>
        <div className="about-l">
          <Img src={AboutImg} loading='lazy' alt="AboutImg" />
        </div>
        <div className="about-r" >
          <div className="about-us" data-aos="slide-left" data-aos-duration='1000'>About Us</div>
          <h1 data-aos="slide-left" data-aos-duration='1000' data-aos-delay='500'>The Leading Real Estate Rental Marketplace.</h1>
          <h5 data-aos="slide-left" data-aos-duration='1000' data-aos-delay='500'>Over 39,000 people work for us in more than 70 countries all over the This breadth of global coverage, combined with specialist services</h5>
          <ul data-aos="fade-in" data-aos-duration='1000' data-aos-delay='1000'>
            <li><i><FaHome /></i> Smart Home Design</li>
            <li><i><FaHome /></i>Beautiful Scene Around</li>
            <li><i><FaHome /></i>Exceptional Lifestyle</li>
            <li><i><FaHome /></i>Complete 24/7 Security</li>
          </ul>
          <div className="summary" data-aos="slide-left" data-aos-duration='1000' data-aos-delay='1000'>
            "Enimad minim veniam quis nostrud exercitation llamco laboris. Lorem ipsum dolor sit amet"
          </div>
        </div>
      </div>
    </>
  )
}

export default About